'use client'
import React, { useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { Button } from "../ButtonElement";
import { Theme } from "../WebsiteThemeElements";
import { animateScroll as scroll } from 'react-scroll'
import {
  InfoContainer,
  InfoWrapper,
  Column1,
  Column2,
  InfoRow,
  ImgWrap,
  Img,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
} from "./InfoElements";
import { Form, FormWrapper } from "../CustomForm/CustomFormElements";

const InfoSection = ({
  lightBg,
  id,
  imgStart,
  topLine,
  headLine,
  description,
  buttonLabel,
  lightText,
  darkText,
  img,
  alt,
  primary,
  dark,
  dark2,
  isCircular,
  to,
}) => {

useEffect(() => {
  return
  
}, [])

const toggleHome = () => {
  scroll.scrollToTop();
}

  return (
    <>
        <InfoContainer lightBg={lightBg} id={id}>
          <InfoWrapper>
            
            <InfoRow right imgStart={imgStart}>
            
              <Column1>
                <TextWrapper>
                  <FormWrapper style={{backgroundColor: 'transparent'}}>
                    <Form style={{backgroundColor: 'transparent'}}>
                  <TopLine>{topLine}</TopLine>
                  <Heading lightText={lightText}>{headLine}</Heading>
                  <Subtitle darkText={darkText}>{description}</Subtitle>
                  <BtnWrap>{ buttonLabel &&
                      <Button href={to}
                      onClick={toggleHome}
                        primary={primary ? 1 : 0}
                        dark={dark ? 1 : 0}>
                        {buttonLabel}
                      </Button>}
                  </BtnWrap></Form></FormWrapper>
                </TextWrapper>

              </Column1>
              
              
              <Column2>
         
                <ImgWrap>
                  <Img onContextMenu={(e) => {e.preventDefault()}} src={img} alt={alt} isCircular={isCircular} />
                </ImgWrap>
              
              </Column2> 
              
            </InfoRow>
          </InfoWrapper>
        </InfoContainer>
    </>
  );
};

export default InfoSection;
